/*

 * Hokkaido Luxury Trip — ツアー詳細ページ動作 (vanilla JS)

 * 元サイトServiceDetailの挙動を再現し、予約はShopifyカート(line item properties)に連携する。

 */

(function () {

  'use strict';

  var docClickBound = false;

  function initTour() {

    var dataEl = document.getElementById('hlt-tour-data');

    if (!dataEl) return;

    var cfg;

    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }



    var state = { guests: 1, date: null, time: cfg.fixedTime || cfg.defaultTime, image: 0 };



    function money(amount) {

      var n = Math.round(amount / 100);

      var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      var fmt = cfg.moneyFormat || '¥{{amount_no_decimals}}';

      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');

    }



    /* ---------- ギャラリー ---------- */

    var heroPc = document.getElementById('hlt-hero-pc');

    var heroSp = document.getElementById('hlt-hero-sp');

    function setImage(i) {

      var n = cfg.images.length;

      if (!n) return;

      state.image = ((i % n) + n) % n;

      var src = cfg.images[state.image];

      if (heroPc) heroPc.src = src;

      if (heroSp) heroSp.src = src;

      var pcDots = document.querySelectorAll('#hlt-dots-pc [data-hlt-dot]');

      pcDots.forEach(function (d, idx) {

        d.className = 'w-2 h-2 rounded-full transition-colors ' + (idx === state.image ? 'bg-accent' : 'bg-white/50');

      });

      var spDots = document.querySelectorAll('#hlt-dots-sp > div');

      spDots.forEach(function (d, idx) {

        d.className = 'w-2 h-2 rounded-full transition-colors shadow-sm ' + (idx === state.image ? 'bg-gray-800 dark:bg-white' : 'bg-gray-800/40 dark:bg-white/40 ring-1 ring-white/30 dark:ring-transparent');

      });

      document.querySelectorAll('[data-hlt-thumb]').forEach(function (t) {

        var idx = parseInt(t.getAttribute('data-hlt-thumb'), 10);

        t.className = 'relative aspect-square rounded-lg overflow-hidden transition-all ' + (idx === state.image ? 'ring-2 ring-accent ring-offset-2 ring-offset-foreground' : 'opacity-70 hover:opacity-100');

      });

    }

    document.querySelectorAll('[data-hlt-prev]').forEach(function (b) { b.addEventListener('click', function () { setImage(state.image - 1); }); });

    document.querySelectorAll('[data-hlt-next]').forEach(function (b) { b.addEventListener('click', function () { setImage(state.image + 1); }); });

    document.querySelectorAll('[data-hlt-dot]').forEach(function (b) { b.addEventListener('click', function () { setImage(parseInt(b.getAttribute('data-hlt-dot'), 10)); }); });

    document.querySelectorAll('[data-hlt-thumb]').forEach(function (b) { b.addEventListener('click', function () { setImage(parseInt(b.getAttribute('data-hlt-thumb'), 10)); }); });

    if (heroSp) {

      var sx = null;

      heroSp.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });

      heroSp.addEventListener('touchend', function (e) {

        if (sx === null) return;

        var dx = e.changedTouches[0].clientX - sx;

        if (Math.abs(dx) > 40) setImage(state.image + (dx < 0 ? 1 : -1));

        sx = null;

      }, { passive: true });

    }



    /* ---------- ライトボックス(モザイク画像タップで全画面) ---------- */

    var lbImgs = cfg.images || [];

    var lbIdx = 0, lbEl = null;

    function lbShow(i) {

      var n = lbImgs.length; if (!n) return;

      lbIdx = ((i % n) + n) % n;

      if (!lbEl) {

        lbEl = document.createElement('div');

        lbEl.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.92);display:flex;align-items:center;justify-content:center;';

        lbEl.innerHTML = '<button data-lb-close aria-label="Close" style="position:absolute;top:16px;right:16px;width:44px;height:44px;border-radius:9999px;background:rgba(255,255,255,.15);color:#fff;font-size:24px;border:0;cursor:pointer;">×</button><button data-lb-prev aria-label="Previous" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:9999px;background:rgba(255,255,255,.15);color:#fff;font-size:28px;border:0;cursor:pointer;">‹</button><img data-lb-img alt="" style="max-width:92vw;max-height:86vh;object-fit:contain;border-radius:8px;"><button data-lb-next aria-label="Next" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:9999px;background:rgba(255,255,255,.15);color:#fff;font-size:28px;border:0;cursor:pointer;">›</button><div data-lb-count style="position:absolute;bottom:20px;left:50%;transform:translateX(-50%);color:#fff;font-size:14px;"></div>';

        document.body.appendChild(lbEl);

        lbEl.addEventListener('click', function (e) { if (e.target === lbEl || e.target.closest('[data-lb-close]')) lbClose(); });

        lbEl.querySelector('[data-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx - 1); });

        lbEl.querySelector('[data-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx + 1); });

      }

      lbEl.style.display = 'flex';

      lbEl.querySelector('[data-lb-img]').src = lbImgs[lbIdx];

      lbEl.querySelector('[data-lb-count]').textContent = (lbIdx + 1) + ' / ' + n;

    }

    function lbClose() { if (lbEl) lbEl.style.display = 'none'; }

    document.querySelectorAll('[data-hlt-lightbox]').forEach(function (b) {

      b.addEventListener('click', function () { lbShow(parseInt(b.getAttribute('data-hlt-lightbox'), 10) || 0); });

    });

    document.addEventListener('keydown', function (e) {

      if (!lbEl || lbEl.style.display === 'none') return;

      if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbIdx - 1); else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);

    });



    /* ---------- 全画像プレビュー(GYG風フォトウォール) ----------

       2026-09-01 事業主指示: 「枚数」バッジ/「View all」を押したら1枚に注力せず全画像の一覧を出す。

       並びは読み順(左上→右→次の段)。段ごとに高さを揃えて幅いっぱいに敷き詰める

       ジャスティファイド方式(縦横比は cfg.imageRatios ＝Liquidの media.aspect_ratio)。

       一覧の写真をタップすると従来の1枚表示(lbShow)が上に開く。 */

    var gwEl = null, gwItems = null;

    function gwIsDark() { return document.documentElement.classList.contains('dark') || document.body.classList.contains('dark'); }

    function gwLayout() {

      if (!gwEl || !gwItems) return;

      var dark = gwIsDark();

      gwEl.style.background = dark ? '#1a1a1a' : '#ffffff';

      var c = gwEl.querySelector('[data-gw-close]');

      c.style.background = dark ? 'rgba(255,255,255,.12)' : '#ffffff';

      c.style.color = dark ? '#e8eaed' : '#2a2724';

      var inner = gwEl.querySelector('[data-gw-wrap]');

      var W = inner.clientWidth;

      if (!W) return;

      var GAP = 8;

      var target = window.innerWidth < 768 ? 150 : 240; /* 段の目標の高さ */

      inner.textContent = '';

      var row = [], sum = 0;

      function flush(isLast) {

        if (!row.length) return;

        var h = (W - GAP * (row.length - 1)) / sum;

        if (isLast && h > target) h = target; /* 最終段は間延びさせず左詰め */

        var div = document.createElement('div');

        div.style.cssText = 'display:flex;gap:' + GAP + 'px;margin:0 0 ' + GAP + 'px;';

        for (var k = 0; k < row.length; k++) {

          row[k].el.style.width = (row[k].r * h) + 'px';

          row[k].el.style.height = h + 'px';

          div.appendChild(row[k].el);

        }

        inner.appendChild(div);

        row = []; sum = 0;

      }

      for (var i = 0; i < gwItems.length; i++) {

        row.push(gwItems[i]); sum += gwItems[i].r;

        if (sum * target >= W - GAP * (row.length - 1)) flush(false);

      }

      flush(true);

    }

    function gwShow() {

      var n = lbImgs.length; if (!n) return;

      if (!gwEl) {

        gwEl = document.createElement('div');

        gwEl.style.cssText = 'position:fixed;inset:0;z-index:9998;overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;display:none;';

        var close = document.createElement('button');

        close.setAttribute('data-gw-close', '');

        close.setAttribute('aria-label', 'Close');

        close.textContent = '×';

        close.style.cssText = 'position:fixed;top:16px;left:16px;z-index:2;width:44px;height:44px;border-radius:9999px;border:0;cursor:pointer;font-size:26px;line-height:1;box-shadow:0 2px 10px rgba(0,0,0,.18);';

        var pad = document.createElement('div');

        pad.style.cssText = 'max-width:1240px;margin:0 auto;padding:76px 16px 40px;';

        var wrap = document.createElement('div');

        wrap.setAttribute('data-gw-wrap', '');

        var ratios = cfg.imageRatios || [];

        gwItems = [];

        for (var i = 0; i < n; i++) {

          var im = document.createElement('img');

          im.src = lbImgs[i];

          im.alt = document.title + ' ' + (i + 1);

          im.loading = 'lazy';

          im.decoding = 'async';

          im.setAttribute('data-gw-i', i);

          im.style.cssText = 'display:block;flex:0 0 auto;object-fit:cover;border-radius:12px;cursor:pointer;background:rgba(128,128,128,.12);';

          gwItems.push({ el: im, r: (ratios[i] > 0 ? ratios[i] : 1.5) });

        }

        pad.appendChild(wrap);

        gwEl.appendChild(close);

        gwEl.appendChild(pad);

        document.body.appendChild(gwEl);

        close.addEventListener('click', gwClose);

        wrap.addEventListener('click', function (e) {

          var t = e.target.closest('[data-gw-i]');

          if (t) lbShow(parseInt(t.getAttribute('data-gw-i'), 10) || 0);

        });

        window.addEventListener('resize', function () { if (gwEl.style.display !== 'none') gwLayout(); });

      }

      gwEl.style.display = 'block';

      gwEl.scrollTop = 0;

      gwLayout(); /* display:block後に測らないと幅が0になる */

      document.body.setAttribute('data-gw-lock', document.body.style.overflow || '');

      document.body.style.overflow = 'hidden';

    }

    function gwClose() {

      if (!gwEl) return;

      gwEl.style.display = 'none';

      document.body.style.overflow = document.body.getAttribute('data-gw-lock') || '';

      document.body.removeAttribute('data-gw-lock');

    }

    document.querySelectorAll('[data-hlt-gallery-all]').forEach(function (b) {

      b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); gwShow(); });

    });

    document.addEventListener('keydown', function (e) {

      if (e.key !== 'Escape') return;

      if (lbEl && lbEl.style.display !== 'none') return; /* 1枚表示が開いていればそちらのESCが先 */

      if (gwEl && gwEl.style.display === 'block') gwClose();

    });



    /* ---------- SP: 予約フォームをGYGモバイルと同じ位置へ移動 ----------

       2026-09-01 事業主指示: 詳細カード直下ではなく「内容を全部見せてから予約」
       (ルート→ハイライト→詳細説明→含まれる→含まれない→ガイド→予約→集合場所…)。

       予約カードのHTMLは従来どおり main(hlt-x-product) が出力する
       (hotel_qr_check の静的検査「スマホ用の予約カードが出力される」を壊さないため)。
       ここでは表示位置だけDOM移動する。このJSはBokunローダー(非同期CDN)より先に実行される
       ので、ウィジェットのiframe再読込は起きない。移動先が見つからなければ何もしない＝従来位置。 */

    (function () {

      var spCard = document.querySelector('[data-hlt-sp-card]');

      if (!spCard) return;

      var wrapEl = spCard.parentElement;

      if (!wrapEl || !wrapEl.parentNode) return;

      /* 2026-09-01 事業主指示で「予約カード ↔ Your guide」を入れ替え:
         予約カードは **Your guide の前**（＝含まれないものの直後）に置く。
         リストは「見つかった最初のものの直後に入れる」順。__p_guide を外し、
         代わりに __p_notincluded を先頭にしたので、予約カード → Your guide の並びになる。 */
      /* 2026-09-02: 「含まれないもの」は「Included」に統合され、__p_notincluded は存在しなくなった */
      var order = ['__p_included', '__p_desc', '__p_highlights', '__p_route'];

      var anchor = null;

      for (var i = 0; i < order.length && !anchor; i++) {

        anchor = document.querySelector('[id$="' + order[i] + '"]');

      }

      if (!anchor || !anchor.parentNode) return;

      /* 移動が成立したときだけ、空になる元の入れ物に目印を付ける。
         CSS側(hlt-x-product)がこの目印を見てスマホで display:none にする。
         🚨 移動に失敗するとこの行に来ないので、予約カードが消えることはない。 */
      var oldBox = wrapEl.parentNode;

      if (oldBox && oldBox.classList) oldBox.classList.add('hlt-sp-emptied');

      wrapEl.classList.add('hlt-sp-only'); /* PCでは非表示(PC用は右カラムの予約パネル) */

      wrapEl.classList.add('px-4');        /* mainの列が持っていた左右16pxを移動先でも維持 */

      anchor.parentNode.insertBefore(wrapEl, anchor.nextSibling);

    })();



    /* ---------- 横スクロールギャラリー: PC/マウス対応(矢印・ホイール・ドラッグ) ---------- */

    var gscroll = document.querySelector('[data-hlt-gallery-scroll]');

    if (gscroll) {

      var gBy = function (dir) { gscroll.scrollBy({ left: dir * gscroll.clientWidth * 0.8, behavior: 'smooth' }); };

      document.querySelectorAll('[data-hlt-gscroll-prev]').forEach(function (b) { b.addEventListener('click', function () { gBy(-1); }); });

      document.querySelectorAll('[data-hlt-gscroll-next]').forEach(function (b) { b.addEventListener('click', function () { gBy(1); }); });

      gscroll.addEventListener('wheel', function (e) {

        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { gscroll.scrollLeft += e.deltaY; e.preventDefault(); }

      }, { passive: false });

      var gDown = false, gStartX = 0, gStartL = 0, gMoved = false;

      gscroll.addEventListener('mousedown', function (e) { gDown = true; gMoved = false; gStartX = e.pageX; gStartL = gscroll.scrollLeft; });

      window.addEventListener('mousemove', function (e) {

        if (!gDown) return;

        var dx = e.pageX - gStartX;

        if (Math.abs(dx) > 4) gMoved = true;

        gscroll.scrollLeft = gStartL - dx;

      });

      window.addEventListener('mouseup', function () { gDown = false; });

      gscroll.addEventListener('click', function (e) { if (gMoved) { e.preventDefault(); e.stopPropagation(); gMoved = false; } }, true);

      /* カルーセルのドット(現在位置) */

      var carDots = document.querySelectorAll('[data-hlt-cdot]');

      if (carDots.length) {

        var updDots = function () {

          var max = gscroll.scrollWidth - gscroll.clientWidth;

          var frac = max > 0 ? gscroll.scrollLeft / max : 0;

          var active = Math.round(frac * (carDots.length - 1));

          carDots.forEach(function (d, i) {

            var on = i === active;

            d.style.width = on ? '8px' : '6px';

            d.style.height = on ? '8px' : '6px';

            d.style.background = on ? '#ffffff' : 'rgba(255,255,255,.55)';

          });

        };

        gscroll.addEventListener('scroll', updDots, { passive: true });

        updDots();

      }

    }



    /* ---------- 戻る/共有/レビューへ ---------- */

    document.querySelectorAll('[data-hlt-back]').forEach(function (b) {

      b.addEventListener('click', function () { if (history.length > 1) history.back(); else location.href = '/'; });

    });

    document.querySelectorAll('[data-hlt-share]').forEach(function (b) {

      b.addEventListener('click', function () {

        if (navigator.share) navigator.share({ title: document.title, url: location.href }).catch(function () {});

        else if (navigator.clipboard) navigator.clipboard.writeText(location.href);

      });

    });

    document.querySelectorAll('[data-hlt-to-reviews]').forEach(function (b) {

      b.addEventListener('click', function () {

        var els = document.querySelectorAll('#reviews, [data-hlt-reviews]');

        for (var i = 0; i < els.length; i++) {

          if (els[i].offsetParent !== null) { els[i].scrollIntoView({ behavior: 'smooth' }); return; }

        }

      });

    });



    /* ---------- モバイルアコーディオン ---------- */

    document.querySelectorAll('[data-hlt-acc]').forEach(function (btn) {

      btn.addEventListener('click', function () {

        var panel = btn.nextElementSibling;

        var chev = btn.querySelector('svg.lucide-chevron-down');

        if (!panel) return;

        var open = panel.classList.contains('hlt-acc-open');

        if (open) {

          panel.classList.remove('hlt-acc-open');

          if (chev) chev.classList.remove('rotate-180');

        } else {

          panel.classList.add('hlt-acc-open');

          if (chev) chev.classList.add('rotate-180');

        }

      });

    });



    /* レビューカードの本文は3行で切り、はみ出すときだけ「See more」を出す(2026-09-01 事業主指示)。
       ※「下のレビュー欄へジャンプ」は2026-09-01に事業主指示で撤去した。
       See more は本文の最終行に重ねて右寄せで出す(GYG式・被ってよいと事業主確認済み)。 */

    function hltBindRevClamps(root) {

      (root || document).querySelectorAll('[data-hlt-rev-toggle]').forEach(function (btn) {

        if (btn.getAttribute('data-hlt-bound')) return;

        btn.setAttribute('data-hlt-bound', '1');

        var p = btn.parentElement ? btn.parentElement.querySelector('[data-hlt-rev-clamp]') : null;

        if (!p) return;

        function check() { if (p.getAttribute('data-open') !== '1') btn.style.display = (p.scrollHeight > p.clientHeight + 4) ? 'block' : 'none'; }

        btn.addEventListener('click', function (e) {

          e.stopPropagation();

          if (p.getAttribute('data-open') === '1') {

            p.setAttribute('data-open', '0'); p.style.display = '-webkit-box'; p.style.webkitLineClamp = '3'; p.style.overflow = 'hidden';

            btn.textContent = btn.getAttribute('data-more');

          } else {

            p.setAttribute('data-open', '1'); p.style.display = 'block'; p.style.webkitLineClamp = 'unset'; p.style.overflow = 'visible';

            btn.textContent = btn.getAttribute('data-less');

          }

        });

        check();

        window.addEventListener('resize', check);

      });

    }

    hltBindRevClamps(document);



    /* ---------- What travelers loved: 実在レビューの自動表示 ----------

       2026-09-01 事業主指示「勝手にいい感じのを自動表示して」。
       出すのは**下のレビュー欄と同じ合算API(TripAdvisor/Google・実在レビューのみ)**の上位2件。
       ★4以上・本文40字以上を、評価→新しさの順で選ぶ。レビューの作文は絶対にしない（景表法）。
       手動の「レビュー」ブロックがある商品ではこのコードは動かない（Liquid側でコンテナ自体が出ない）。 */

    (function () {

      var boxes = document.querySelectorAll('[data-hlt-loved]');

      if (!boxes.length) return;

      var url = boxes[0].getAttribute('data-endpoint');

      var exp = boxes[0].getAttribute('data-exp');

      if (!url || !exp) return;

      function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

      fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'exp=' + encodeURIComponent(exp))

        .then(function (r) { return r.json(); })

        .then(function (d) {

          var items = (d && d.items) || [];

          items = items.filter(function (it) { return (it.rating || 0) >= 4 && it.text && String(it.text).length >= 40; });

          items.sort(function (a, b) { return (b.rating - a.rating) || (new Date(b.date || 0) - new Date(a.date || 0)); });

          items = items.slice(0, 2);

          if (!items.length) return;

          var moreL = boxes[0].getAttribute('data-more') || 'See more';

          var lessL = boxes[0].getAttribute('data-less') || 'Hide details';

          var html = items.map(function (it) {

            var stars = '';

            for (var i = 1; i <= 5; i++) stars += '<span style="font-size:16px;line-height:1;color:' + (i <= Math.round(it.rating) ? '#e8853b' : '#d1d5db') + ';">★</span>';

            var dt = '';

            if (it.date) { try { dt = new Date(it.date).toISOString().slice(0, 10); } catch (e) { } }

            var meta = esc(dt) + (it.platform ? (dt ? ' · ' : '') + esc(it.platform) : '');

            var name = esc(it.author || 'Traveler');

            return '<div class="border border-gray-200 rounded-2xl p-4">' +

              '<div class="flex items-center mb-2" style="gap:2px;">' + stars + '</div>' +

              '<div class="flex items-center gap-2.5">' +

              '<div class="flex items-center justify-center flex-shrink-0" style="width:36px;height:36px;border-radius:9999px;background:#2a2724;"><span style="color:#fff;font-weight:600;font-size:15px;">' + esc(String(it.author || 'T').charAt(0).toUpperCase()) + '</span></div>' +

              '<div><p style="color:#2a2724;font-weight:600;font-size:14px;font-family:\'Manrope\',sans-serif;">' + name + '</p>' +

              '<p style="color:#63687a;font-size:12px;">' + meta + '</p></div>' +

              '</div>' +

              '<p data-hlt-rev-clamp class="leading-relaxed mt-2" style="color:#374151;font-size:14px;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;">' + esc(it.text) + '</p>' +

              '<button type="button" data-hlt-rev-toggle data-more="' + esc(moreL) + '" data-less="' + esc(lessL) + '" class="font-semibold" style="display:none;margin-top:-2px;margin-left:auto;color:#e8853b;font-size:13px;background:none;border:0;padding:0 0 0 8px;cursor:pointer;text-decoration:underline;">' + esc(moreL) + '</button>' +

              '</div>';

          }).join('');

          boxes.forEach(function (b) {

            var wrap = b.querySelector('[data-loved-cards]');

            if (!wrap) return;

            wrap.innerHTML = html;

            b.style.display = '';

            hltBindRevClamps(wrap);

          });

        })

        .catch(function () { });

    })();



    /* ---------- ドロップダウン開閉 ---------- */

    function closeAllPanels(except) {

      document.querySelectorAll('[data-hlt-guests-panel],[data-hlt-calendar],[data-hlt-time-panel]').forEach(function (p) {

        if (p !== except) p.style.display = 'none';

      });

    }

    if (!docClickBound) {

      docClickBound = true;

      document.addEventListener('click', function (e) {

        if (!e.target.closest('[data-hlt-guests-btn],[data-hlt-guests-panel],[data-hlt-date-btn],[data-hlt-calendar],[data-hlt-time-btn],[data-hlt-time-panel]')) closeAllPanels(null);

      });

    }



    /* ---------- 人数 ---------- */

    function renderGuests() {

      document.querySelectorAll('[data-hlt-guests-num]').forEach(function (el) { el.textContent = String(state.guests); });

      document.querySelectorAll('[data-hlt-guests-btn-label]').forEach(function (el) { el.textContent = 'Guests x' + state.guests; });

      updatePrices();

      updateOptionCard();

    }

    document.querySelectorAll('[data-hlt-guests-btn]').forEach(function (btn) {

      btn.addEventListener('click', function (e) {

        e.stopPropagation();

        /* スマホは中央ポップアップ(モーダル)で人数選択。PCは従来のインラインパネル */
        if (window.matchMedia && window.matchMedia('(max-width:767.98px)').matches) {

          closeAllPanels(null);

          openNumModal();

          return;

        }

        var panel = btn.parentElement.querySelector('[data-hlt-guests-panel]');

        if (!panel) return;

        var visible = panel.style.display !== 'none';

        closeAllPanels(null);

        panel.style.display = visible ? 'none' : 'block';

      });

    });

    document.querySelectorAll('[data-hlt-minus]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); state.guests = Math.max(1, state.guests - 1); renderGuests(); updateOptionCard(); }); });

    document.querySelectorAll('[data-hlt-plus]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); state.guests = Math.min(cfg.maxGuests || 99, state.guests + 1); renderGuests(); updateOptionCard(); }); });



    /* ---------- 価格表示(1人あたり課金なら人数連動) ---------- */

    function updatePrices() {

      var total = cfg.perPerson ? cfg.price * state.guests : cfg.price;

      document.querySelectorAll('[data-hlt-total]').forEach(function (el) { el.textContent = money(total); });

    }



    /* ---------- カレンダー ---------- */

    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    var DOW = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']; /* 月曜始まり */

    function fmtDate(d) { return MONTHS[d.getMonth()].slice(0, 3) + ' ' + d.getDate() + ', ' + d.getFullYear(); }

    function isoDate(d) {

      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');

    }

    /* ---------- 空き状況(P1: 満席ブロック) ----------
       cfg.blockedDates: 手動ブロック日 / cfg.booked: Shopify予約 / cfg.otaBooked: GYG/Airbnb予約
       いずれも {"YYYY-MM-DD":{"b":件数,"g":人数}} / cfg.onePerDay: 1日1組限定 / cfg.capacity: 1日の合計人数上限 */
    function availInfo(dstr) {
      /* reason: 'blocked'=こちらで手動ブロック / 'full'=満席(定員・1日1組)。Shopify予約とOTA予約(GYG/Airbnb)を合算して残席判定 */
      if ((cfg.blockedDates || []).indexOf(dstr) >= 0) return { full: true, left: 0, reason: 'blocked' };
      var rec = (cfg.booked || {})[dstr];
      var ota = (cfg.otaBooked || {})[dstr];
      var b = (rec ? (rec.b || 0) : 0) + (ota ? (ota.b || 0) : 0), g = (rec ? (rec.g || 0) : 0) + (ota ? (ota.g || 0) : 0);
      if (cfg.onePerDay && b >= 1) return { full: true, left: 0, reason: 'full' };
      var cap = parseInt(cfg.capacity, 10) || 0;
      if (cap > 0) {
        var left = cap - g;
        return left <= 0 ? { full: true, left: 0, reason: 'full' } : { full: false, left: left };
      }
      return { full: false, left: null };
    }
    /* 1ヶ月分のグリッド(曜日ヘッダーは上部sticky側に共通表示するのでここには含めない) */
    function monthGrid(y, m) {
      var first = new Date(y, m, 1);
      /* 「今日」は日本時間(Asia/Tokyo)基準 — 海外の顧客のブラウザ時計に依存させない */
      var jstParts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo' }).format(new Date()).split('-');
      var today = new Date(parseInt(jstParts[0], 10), parseInt(jstParts[1], 10) - 1, parseInt(jstParts[2], 10));
      var minSel = new Date(today); minSel.setDate(minSel.getDate() + (parseInt(cfg.minLeadDays, 10) || 0));
      var priceStr = cfg.priceMoney || money(cfg.price);
      var html = '<div class="hlt-cal-month"><h4 class="hlt-cal-mtitle">' + MONTHS[first.getMonth()] + ' ' + first.getFullYear() + '</h4><div class="hlt-cal-mweek">' + DOW.map(function (wd) { return '<div class="hlt-cal-wd">' + wd + '</div>'; }).join('') + '</div><div class="hlt-cal-grid">';
      /* 月曜始まり: 日曜(getDay=0)を末尾に回す先頭空白 */
      var lead = (first.getDay() + 6) % 7;
      for (var i = 0; i < lead; i++) html += '<div class="hlt-cal-cell hlt-cal-empty"></div>';
      var days = new Date(y, m + 1, 0).getDate();
      for (var d = 1; d <= days; d++) {
        var dt = new Date(y, m, d);
        var past = dt <= minSel;
        var dstr = isoDate(dt);
        var av = past ? null : availInfo(dstr);
        var sel = state.date && isoDate(dt) === isoDate(state.date);
        if (past) {
          html += '<button type="button" disabled class="hlt-cal-cell hlt-cal-past"><span class="hlt-cal-num">' + d + '</span></button>';
        } else if (av && av.full) {
          /* 満席も手動ブロックも顧客には「予約不可」の一種 — 同じグレー表示に統一 */
          html += '<button type="button" disabled class="hlt-cal-cell hlt-cal-off"><span class="hlt-cal-num" style="text-decoration:line-through;">' + d + '</span></button>';
        } else {
          var hasLeft = av && av.left !== null;
          var lowLeft = hasLeft && av.left <= 3;
          var inner = '<span class="hlt-cal-num">' + d + '</span>';
          if (priceStr) inner += '<span class="hlt-cal-price">' + priceStr + '</span>';
          if (hasLeft) inner += '<span class="hlt-cal-left' + (lowLeft ? ' is-low' : '') + '">' + av.left + ' left</span>';
          html += '<button type="button" data-hlt-day="' + dstr + '" class="hlt-cal-cell hlt-cal-open' + (sel ? ' is-sel' : '') + '">' + inner + '</button>';
        }
      }
      html += '</div></div>';
      return html;
    }

    /* ===== カレンダー モーダル(PC=画面中央 / SP=全画面・縦スクロール) ===== */
    var CAL_MONTHS_AHEAD = 12; /* 今月から先に出す月数(SP=縦に全部 / PC=2ヶ月ずつ矢印送り) */
    var calModal = null, numModal = null, calPcBase = 0;
    injectCalCss(); /* CSS(モーダル+インライントグルのアニメ)を先に注入 */

    function injectCalCss() {
      if (document.getElementById('hlt-cal-css')) return;
      var s = document.createElement('style');
      s.id = 'hlt-cal-css';
      s.textContent = [
        '.hlt-cal-modal{position:fixed;inset:0;z-index:100000;visibility:hidden;transition:visibility 0s linear .38s;}',
        '.hlt-cal-modal.is-open{visibility:visible;transition:visibility 0s;}',
        '.hlt-cal-backdrop{position:absolute;inset:0;background-color:rgba(0,0,0,.5) !important;opacity:0;transition:opacity .32s ease;}',
        '.hlt-cal-modal.is-open .hlt-cal-backdrop{opacity:1;}',
        '.hlt-cal-panel{position:absolute;inset:0;background:#fff;color:#1f2937;display:flex;flex-direction:column;overflow:hidden;font-family:inherit;transform:translateY(-100%);transition:transform .38s cubic-bezier(.4,0,.2,1);will-change:transform;}',
        '.hlt-cal-modal.is-open .hlt-cal-panel{transform:translateY(0);}',
        '@media(min-width:768px){.hlt-cal-panel{inset:auto;top:50%;left:50%;width:min(720px,95vw);max-height:88vh;border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.3);transform:translate(-50%,-62%);opacity:0;transition:transform .3s cubic-bezier(.4,0,.2,1),opacity .3s ease;}.hlt-cal-modal.is-open .hlt-cal-panel{transform:translate(-50%,-50%);opacity:1;}}',
        '.hlt-cal-head{flex-shrink:0;display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eef1f4;}',
        '.hlt-cal-title{font-size:16px;font-weight:700;color:#1a2b49;}',
        '.hlt-cal-x{background:#f1f3f7;border:0;width:34px;height:34px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;color:#1a2b49;cursor:pointer;}',
        '.hlt-cal-x:hover{background:#e6e8ee;}',
        '.hlt-cal-week{flex-shrink:0;display:grid;grid-template-columns:repeat(7,1fr);gap:4px;padding:10px 14px;border-bottom:1px solid #eef1f4;background:#fff;}',
        '.hlt-cal-mweek{display:none;grid-template-columns:repeat(7,1fr);gap:4px;margin-bottom:6px;}',
        '.hlt-cal-wd{text-align:center;font-size:11px;font-weight:600;color:#9aa1ac;}',
        '.hlt-cal-body{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:2px 14px 28px;}',
        '.hlt-cal-month{margin-top:16px;}',
        '.hlt-cal-mtitle{font-size:14px;font-weight:700;color:#1a2b49;text-align:center;margin:0 0 8px;}',
        '.hlt-cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:4px;}',
        '.hlt-cal-cell{min-height:54px;display:flex;flex-direction:column;align-items:center;justify-content:center;border-radius:10px;padding:2px;font-family:inherit;border:0;background:transparent;overflow:hidden;}',
        '.hlt-cal-empty{min-height:54px;}',
        '.hlt-cal-num{font-size:15px;font-weight:600;line-height:1.1;color:#1f2937;}',
        '.hlt-cal-price{font-size:10px;font-weight:600;line-height:1.25;letter-spacing:-.2px;white-space:nowrap;color:#b4611f;margin-top:1px;}',
        '.hlt-cal-left{font-size:9px;font-weight:700;line-height:1.1;color:#2f7a4d;}',
        '.hlt-cal-left.is-low{color:#c0392b;}',
        '.hlt-cal-open{cursor:pointer;transition:background-color .12s;}',
        '.hlt-cal-open:hover{background-color:#fff3e9;}',
        '.hlt-cal-open.is-sel{background-color:oklch(0.55 0.15 45);}',
        '.hlt-cal-open.is-sel .hlt-cal-num,.hlt-cal-open.is-sel .hlt-cal-price{color:#fff;}',
        '.hlt-cal-open.is-sel .hlt-cal-left{color:#ffe9d6;}',
        '.hlt-cal-past{cursor:not-allowed;background-color:#f6f7f9;}',
        '.hlt-cal-past .hlt-cal-num{color:#cfd4dc;}',
        '.hlt-cal-off{cursor:not-allowed;background-color:#e4e7ec;}',
        '.hlt-cal-off .hlt-cal-num{color:#aab0bb;}',
        '.hlt-num-modal{position:fixed;inset:0;z-index:100000;visibility:hidden;transition:visibility 0s linear .3s;}',
        '.hlt-num-modal.is-open{visibility:visible;transition:visibility 0s;}',
        '.hlt-num-backdrop{position:absolute;inset:0;background-color:rgba(0,0,0,.5) !important;opacity:0;transition:opacity .28s ease;}',
        '.hlt-num-modal.is-open .hlt-num-backdrop{opacity:1;}',
        '.hlt-num-card{position:absolute;top:50%;left:50%;transform:translate(-50%,-64%);opacity:0;transition:transform .3s cubic-bezier(.4,0,.2,1),opacity .28s ease;width:min(300px,86vw);background:#fff;color:#1f2937;border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.3);padding:16px 18px 18px;font-family:inherit;}',
        '.hlt-num-modal.is-open .hlt-num-card{transform:translate(-50%,-50%);opacity:1;}',
        '.hlt-num-head{display:flex;align-items:center;justify-content:space-between;}',
        '.hlt-num-title{font-size:16px;font-weight:700;color:#1a2b49;}',
        '.hlt-num-x{background:#f1f3f7;border:0;width:32px;height:32px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;color:#1a2b49;cursor:pointer;}',
        '.hlt-num-x:hover{background:#e6e8ee;}',
        '.hlt-num-row{display:flex;align-items:center;justify-content:space-between;margin-top:14px;}',
        '.hlt-num-sub{font-size:13px;color:#6b7280;}',
        '.hlt-num-ctrls{display:flex;align-items:center;gap:16px;}',
        '.hlt-num-btn{width:38px;height:38px;border-radius:50%;border:1px solid oklch(0.666 0.179 58.318);background:#fff;color:oklch(0.55 0.15 45);display:inline-flex;align-items:center;justify-content:center;cursor:pointer;font-size:22px;line-height:1;font-family:inherit;}',
        '.hlt-num-btn:hover{background-color:#fff3e9;}',
        '.hlt-num-count{min-width:32px;text-align:center;font-size:18px;font-weight:700;color:#1f2937;}',
        '[data-hlt-guests-panel],[data-hlt-time-panel]{animation:hltDropIn .2s ease;}',
        '@keyframes hltDropIn{from{opacity:0;transform:translateY(-10px);}to{opacity:1;transform:translateY(0);}}',
        '@media(min-width:768px){.hlt-cal-week{display:none;}.hlt-cal-mweek{display:grid;}.hlt-cal-body{display:flex;align-items:flex-start;gap:10px;padding:22px 16px 22px;overflow-y:auto;}.hlt-cal-pcgrid{flex:1 1 auto;min-width:0;display:grid;grid-template-columns:1fr 1fr;gap:0 24px;}.hlt-cal-nav{flex-shrink:0;align-self:center;width:38px;height:38px;border-radius:50%;border:1px solid #e6e8ee;background:#fff;color:#1a2b49;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:background-color .12s;}.hlt-cal-nav:hover{background:#f1f3f7;}.hlt-cal-nav:disabled{opacity:.3;cursor:default;}.hlt-cal-month{margin-top:0;}.hlt-cal-cell,.hlt-cal-empty{min-height:60px;}.hlt-cal-num{font-size:16px;}.hlt-cal-price{font-size:11px;}.hlt-cal-mtitle{font-size:15px;}}',
        'html.hlt-cal-open{overflow:hidden;}',
        'html.hlt-cal-open #shopify-chat,html.hlt-cal-open div[id^="shopify-chat"],html.hlt-cal-open inbox-online-store-chat{display:none !important;}'
      ].join('');
      document.head.appendChild(s);
    }

    function buildCalModal() {
      if (calModal && document.body.contains(calModal)) return calModal;
      var existing = document.getElementById('hlt-cal-modal');
      if (existing) { calModal = existing; return calModal; }
      injectCalCss();
      var m = document.createElement('div');
      m.id = 'hlt-cal-modal';
      m.className = 'hlt-cal-modal';
      m.innerHTML =
        '<div class="hlt-cal-backdrop" data-hlt-cal-close></div>' +
        '<div class="hlt-cal-panel" role="dialog" aria-modal="true" aria-label="Select a date">' +
          '<div class="hlt-cal-head"><span class="hlt-cal-title">Select a date</span>' +
            '<button type="button" class="hlt-cal-x" data-hlt-cal-close aria-label="Close">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>' +
            '</button></div>' +
          '<div class="hlt-cal-week">' + DOW.map(function (d) { return '<div class="hlt-cal-wd">' + d + '</div>'; }).join('') + '</div>' +
          '<div class="hlt-cal-body"></div>' +
        '</div>';
      document.body.appendChild(m);
      m.querySelectorAll('[data-hlt-cal-close]').forEach(function (b) { b.addEventListener('click', closeCalModal); });
      calModal = m;
      return m;
    }

    /* ===== 人数モーダル(スマホ用・中央の小さいポップアップ) ===== */
    function buildNumModal() {
      if (numModal && document.body.contains(numModal)) return numModal;
      var existing = document.getElementById('hlt-num-modal');
      if (existing) { numModal = existing; return numModal; }
      injectCalCss();
      var m = document.createElement('div');
      m.id = 'hlt-num-modal';
      m.className = 'hlt-num-modal';
      m.innerHTML =
        '<div class="hlt-num-backdrop" data-hlt-num-close></div>' +
        '<div class="hlt-num-card" role="dialog" aria-modal="true" aria-label="Guests">' +
          '<div class="hlt-num-head"><span class="hlt-num-title">Guests</span>' +
            '<button type="button" class="hlt-num-x" data-hlt-num-close aria-label="Close">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>' +
            '</button></div>' +
          '<div class="hlt-num-row"><span class="hlt-num-sub">(Under 99)</span>' +
            '<div class="hlt-num-ctrls">' +
              '<button type="button" class="hlt-num-btn" data-hlt-num-minus aria-label="Decrease guests">−</button>' +
              '<span class="hlt-num-count" data-hlt-guests-num>1</span>' +
              '<button type="button" class="hlt-num-btn" data-hlt-num-plus aria-label="Increase guests">+</button>' +
            '</div></div>' +
        '</div>';
      document.body.appendChild(m);
      m.querySelectorAll('[data-hlt-num-close]').forEach(function (b) { b.addEventListener('click', closeNumModal); });
      m.querySelector('[data-hlt-num-minus]').addEventListener('click', function (e) { e.stopPropagation(); state.guests = Math.max(1, state.guests - 1); renderGuests(); });
      m.querySelector('[data-hlt-num-plus]').addEventListener('click', function (e) { e.stopPropagation(); state.guests = Math.min(cfg.maxGuests || 99, state.guests + 1); renderGuests(); });
      numModal = m;
      return m;
    }
    function openNumModal() {
      buildNumModal();
      numModal.querySelectorAll('[data-hlt-guests-num]').forEach(function (el) { el.textContent = String(state.guests); });
      void numModal.offsetWidth; /* リフローで初回オープンでもスライドイン */
      numModal.classList.add('is-open');
      document.documentElement.classList.add('hlt-cal-open');
    }
    function closeNumModal() {
      var m = numModal || document.getElementById('hlt-num-modal');
      if (m) m.classList.remove('is-open');
      document.documentElement.classList.remove('hlt-cal-open');
    }

    function renderCalBody() {
      var body = calModal.querySelector('.hlt-cal-body');
      var jstParts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo' }).format(new Date()).split('-');
      var y0 = parseInt(jstParts[0], 10), m0 = parseInt(jstParts[1], 10) - 1;
      var isPc = window.matchMedia && window.matchMedia('(min-width:768px)').matches;
      var html = '';
      if (isPc) {
        /* PC: 2ヶ月だけ横並び。左右の矢印で月を送る(縦スクロールしない) */
        var maxBase = CAL_MONTHS_AHEAD - 2;
        if (calPcBase < 0) calPcBase = 0;
        if (calPcBase > maxBase) calPcBase = maxBase;
        var chevL = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"></path></svg>';
        var chevR = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"></path></svg>';
        html += '<button type="button" class="hlt-cal-nav" data-hlt-cal-prev aria-label="Previous months"' + (calPcBase <= 0 ? ' disabled' : '') + '>' + chevL + '</button>';
        html += '<div class="hlt-cal-pcgrid">';
        for (var i = 0; i < 2; i++) {
          var nd = new Date(y0, m0 + calPcBase + i, 1);
          html += monthGrid(nd.getFullYear(), nd.getMonth());
        }
        html += '</div>';
        html += '<button type="button" class="hlt-cal-nav" data-hlt-cal-next aria-label="Next months"' + (calPcBase >= maxBase ? ' disabled' : '') + '>' + chevR + '</button>';
      } else {
        for (var j = 0; j < CAL_MONTHS_AHEAD; j++) {
          var nd2 = new Date(y0, m0 + j, 1);
          html += monthGrid(nd2.getFullYear(), nd2.getMonth());
        }
      }
      body.innerHTML = html;
      body.scrollTop = 0;
      var pv = body.querySelector('[data-hlt-cal-prev]');
      if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); calPcBase -= 1; renderCalBody(); });
      var nx = body.querySelector('[data-hlt-cal-next]');
      if (nx) nx.addEventListener('click', function (e) { e.stopPropagation(); calPcBase += 1; renderCalBody(); });
      body.querySelectorAll('[data-hlt-day]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          var parts = b.getAttribute('data-hlt-day').split('-');
          state.date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
          document.querySelectorAll('[data-hlt-date-label]').forEach(function (l) { l.textContent = fmtDate(state.date); });
          closeCalModal();
          enableBooking();
          updateOptionCard();
        });
      });
    }

    function openCalModal() {
      buildCalModal();
      var t = calModal.querySelector('.hlt-cal-title');
      if (t) t.textContent = state.date ? fmtDate(state.date) : 'Select a date';
      calPcBase = 0; /* PCは常に今月から2ヶ月で開く */
      renderCalBody();
      void calModal.offsetWidth; /* リフローで初回オープンでもスライドイン */
      calModal.classList.add('is-open');
      document.documentElement.classList.add('hlt-cal-open');
    }
    function closeCalModal() {
      var m = calModal || document.getElementById('hlt-cal-modal');
      if (m) m.classList.remove('is-open');
      document.documentElement.classList.remove('hlt-cal-open');
    }
    if (!window.__hltCalEscBound) {
      window.__hltCalEscBound = 1;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          var open = document.querySelector('.hlt-cal-modal.is-open, .hlt-num-modal.is-open');
          if (open) { open.classList.remove('is-open'); document.documentElement.classList.remove('hlt-cal-open'); }
        }
      });
    }

    document.querySelectorAll('[data-hlt-date-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeAllPanels(null);
        openCalModal();
      });
    });



    /* ---------- 時間 ---------- */

    function toMin(t) { var p = t.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1], 10); }

    function toHHMM(m) { return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0'); }

    document.querySelectorAll('[data-hlt-time-btn]').forEach(function (btn) {

      btn.addEventListener('click', function (e) {

        e.stopPropagation();

        var panel = btn.parentElement.querySelector('[data-hlt-time-panel]');

        if (!panel) return;

        var visible = panel.style.display !== 'none';

        closeAllPanels(null);

        if (visible) return;

        var html = '';

        var step = parseInt(cfg.timeInterval, 10) || 30;

        for (var m = toMin(cfg.timeStart); m <= toMin(cfg.timeEnd); m += step) {

          var t = toHHMM(m);

          html += '<button type="button" data-hlt-time-opt="' + t + '" class="w-full text-left px-4 py-2.5 hover:bg-gray-50 transition-colors text-gray-900' + (t === state.time ? ' font-semibold bg-orange-50' : '') + '">' + t + '</button>';

        }

        panel.innerHTML = html;

        panel.style.display = 'block';

        panel.querySelectorAll('[data-hlt-time-opt]').forEach(function (o) {

          o.addEventListener('click', function (e2) {

            e2.stopPropagation();

            state.time = o.getAttribute('data-hlt-time-opt');

            document.querySelectorAll('[data-hlt-time-label]').forEach(function (l) { l.textContent = state.time; });

            document.querySelectorAll('[data-hlt-time-btn-label]').forEach(function (l) { l.textContent = 'Preferred Time ' + state.time; });

            panel.style.display = 'none';

            updateOptionCard();

          });

        });

      });

    });



    /* ---------- 予約(カート追加) ---------- */

    function enableBooking() {

      document.querySelectorAll('[data-hlt-book]').forEach(function (b) {

        b.disabled = false;

        if (b.classList.contains('bg-gray-300')) {

          b.classList.remove('bg-gray-300', 'text-gray-500', 'cursor-not-allowed');

          b.classList.add('text-white');

          b.style.backgroundColor = 'oklch(0.55 0.15 45)';

          b.textContent = 'Book Now';

        }

      });

    }

    /* オプションカード(PC=左カラム / SP=予約カード直下)。日付選択で出現、開始時間はカード内に表示 */

    var optionShown = false;

    function updateOptionCard() {

      if (!state.date) return;

      document.querySelectorAll('[data-hlt-optionwrap]').forEach(function (w) { w.style.display = 'block'; });

      document.querySelectorAll('[data-hlt-empty]').forEach(function (el) { el.style.display = 'none'; });

      var cards = document.querySelectorAll('[data-hlt-option]');

      cards.forEach(function (c) { c.style.display = 'block'; });

      document.querySelectorAll('[data-hlt-selection-summary]').forEach(function (el) {

        el.textContent = fmtDate(state.date) + '・Guests x' + state.guests;

      });

      updatePrices();

      if (!optionShown) {

        optionShown = true;

        /* 初回だけ、表示中のカードが視界に入るよう軽くスクロール */

        var visible = Array.prototype.find.call(cards, function (c) { return c.offsetParent; });

        if (visible) setTimeout(function () { visible.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 80);

      }

    }

    function book() {

      if (!state.date) {

        var btn = document.querySelector('[data-hlt-date-btn]');

        if (btn) btn.click();

        return;

      }

      /* P1: 予約直前の残席チェック(定員あり商品) */
      var avNow = availInfo(isoDate(state.date));
      if (avNow.full) { alert('Sorry, this date is fully booked. Please choose another date.'); state.date = null; return; }
      if (avNow.left !== null && (state.guests || 1) > avNow.left) { alert('Only ' + avNow.left + ' seat(s) left on this date. Please reduce the number of guests or choose another date.'); return; }
      var form = document.createElement('form');

      form.method = 'post';

      form.action = '/cart/add';

      function add(name, value) {

        var i = document.createElement('input');

        i.type = 'hidden'; i.name = name; i.value = value;

        form.appendChild(i);

      }

      add('id', cfg.variantId);

      add('quantity', cfg.perPerson ? state.guests : 1);

      add('properties[Date]', fmtDate(state.date));

      add('properties[_date_iso]', isoDate(state.date));

      add('properties[Start Time]', state.time + ' (JST / Japan time)');

      add('properties[Guests]', String(state.guests));

      document.body.appendChild(form);

      form.submit();

    }

    document.querySelectorAll('[data-hlt-book]').forEach(function (b) {

      b.addEventListener('click', function () { if (!b.disabled) book(); });

    });

    document.querySelectorAll('[data-hlt-cta]').forEach(function (b) {

      b.addEventListener('click', function () {

        var card = document.querySelector('[data-loc="client/src/pages/ServiceDetail.tsx:2164"]');

        var target = (card && card.offsetParent) ? card : document.getElementById('reservation-section');

        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      });

    });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initTour);

  } else {

    initTour();

  }

  /* カスタマイザーのセクション再描画に追随(このセクションが差し替わった時だけ再初期化) */

  document.addEventListener('shopify:section:load', function (e) {

    if (e.target && e.target.querySelector && e.target.querySelector('#hlt-tour-data')) initTour();

  });

})();

